<template>
	<form
		:class="[
			'styled-form',
			'styled-form--white-box',
			{'is-loading': isLoading}
		]"
		@submit.prevent="onSubmit"
		name="login_form"
	>

		<div v-if="isLoading" class="styled-form__overlay">
			<div class="preloader"></div>
		</div>

		<global-message v-if="errors.global" :value="errors.global"></global-message>

		<div class="styled-form__corset">
			<div class="styled-form__header">
				<h2 class="styled-form__title">Sign In</h2>
        <h3 class="styled-form__subtitle sign-in-form__subtitle">Sign in with your social account or email address</h3>
			</div>

      <social-connect @socialButtonClick="isLoading = true" />
    </div>

		<div class="styled-form__corset">
			<form-input
				v-model="data.email"
				name="email"
				label="Your Email Address *"
				:error="errors.email"
				class="to-lower-case"
			></form-input>

			<form-input
				v-model="data.password"
				type="password"
				name="password"
				label="Password *"
				:error="errors.password"
			></form-input>

			<div class="password-assist">
				<router-link
					class="password-assist__link password-assist__link"
					:to="{
						name: 'resetPassword',
						params: {
							email: data.email || null
						}
					}"
				>Forgot Password</router-link>

				<tool-tip label="Having trouble signing in?" tid="help-signing">
					<i>Registered last year?</i><br />
          You may have used a different email OR social login.<br />
					<br /><i>Registered prior to 2019?</i><br />
					We’ve updated our system therefore you will need a new account. <a href='/register'>Create account now</a><br />
					<br /><i>Not registered before?</i><br />
					<a href='/register'>Create account now</a><br />
					<br /><i>Need to verify your account?</i><br />
					<a href='/register/verify'>Verify your account</a><br />
					<br /><i>Have another issue?</i><br />
					<a href='https://support.playfootball.com.au/support/home' target='_blank'>Contact Support</a>
				</tool-tip>
			</div>

			<div class="text--center">
				<button class="btn">Continue</button>
			</div>
		</div>

		<horizontal-divider></horizontal-divider>

		<div class="styled-form__corset">
			<div class="register-link text--center">
				<div class="register-link--label">Don’t have an account?</div>
				<router-link
					class="grey-small-btn"
					:to="{name: 'register'}"
				>CREATE ACCOUNT</router-link>
			</div>
		</div>

	</form>
</template>

<style>
	.line-margin {
		margin-top:6px;
	}
	.sign-in-form__subtitle {
		margin-bottom: 35px;
	}
	.password-assist {
		margin-bottom: 40px;
	}
	.register-link {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.register-link--label {
		margin-right: 25px;
	}
</style>

<script>
	import isEmail from '../../helpers/isEmail';
	import GlobalMessage from '../messages/GlobalMessage.vue';
	import FormInput from '../formFields/FormInput.vue';
	import SocialConnect from '../views/SocialConnect.vue';
	import ToolTip from '../common/ToolTip.vue';
	import HorizontalDivider from "../common/HorizontalDivider";

	export default {
		components: {
			ToolTip,
			HorizontalDivider,
			GlobalMessage,
			FormInput,
			SocialConnect
		},
		props: {
			submit: {
				type: Function,
				required: true
			},
			email: String,
            issue: ''
		},
		data() {
			return {
				isLoading: false,
				data: {
					email: '',
					password: '',
				},
				errors: {}
			}
		},
		created() {
			this.validateProps();
		},
		methods: {
			validateProps() {
				if (isEmail(this.email)) {
					let emailProp = this.email;
					this.data.email = emailProp.toLowerCase();
				}
				if (this.issue) {
                    // email used from a social account
                    if (this.issue.indexOf("social account") !== -1) {
                        this.$session.remove('register_email');
                        this.data.email = '';
                    }
				    this.errors = {global: this.issue}
				}
			},
			onSubmit() {
				this.errors = this.validate(this.data);

				if (Object.keys(this.errors).length === 0) {

                    this.data.email = this.data.email.toLowerCase();
					this.isLoading = true;
					this.submit(this.data).catch(errors => {
						if (errors.global == 'User is not confirmed.') {
							return this.$store.dispatch('user/RESEND_CODE', this.data).then(() => {
								// redirect to the verification page
								this.$router.push({
									name: 'verify',
									params: {
										email: this.data.email
									}
								});
							});
						} else {
                            this.isLoading = false;
                            this.errors = errors;

                            if (errors instanceof Error) {
                                // console.error(errors);
                            }
						}
					});
				}
			},
			validate(data) {
				const errors = {};

				if (!data.email.length) {
					errors.email = 'This field is required';
				} else if (!isEmail(data.email)) {
					errors.email = 'Invalid email';
				}
				if (!data.password.length) errors.password = 'This field is required';

				return errors;
			}
		}
	};
</script>
